import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-development",
  "use": "spr-development-usage",
  "viewBox": "0 0 48 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 38\" id=\"spr-development\"><defs><path id=\"spr-development_a\" d=\"M967 784h-46a1 1 0 1 1 0-2h11v-22.33a7 7 0 1 1-2-13.68h28a7 7 0 0 1 7 6.99 7 7 0 0 1-9 6.7V782h11a1 1 0 1 1 0 2zm-32.1-36.01a6.95 6.95 0 0 1 2.1 4.99h14c0-1.95.8-3.72 2.1-4.99zm1.8 6.98a7.01 7.01 0 0 1-2.7 3.74v5.24a4 4 0 0 1 4 4V782h2v-14.06a4 4 0 0 1 8 0V782h2v-14.06a4 4 0 0 1 4-3.99v-5.24a7.01 7.01 0 0 1-2.7-3.74zM936 782v-14.06a2 2 0 0 0-2-2V782zm16-14.06V782h2v-16.05a2 2 0 0 0-2 2zM946 782v-14.06a2 2 0 0 0-4 0V782zm-16-34a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm28 0a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm9 23.94h-7a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2zm-39 0h-7a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2zm34 5.99h-2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2zm-34-11.97h-2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2z\" /></defs><use fill=\"#cd9932\" xlink:href=\"#spr-development_a\" transform=\"translate(-920 -746)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/development.svg
// module id = 252
// module chunks = 0